import { render } from "./GoTop.vue?vue&type=template&id=5860b910"
import script from "./GoTop.vue?vue&type=script&lang=js"
export * from "./GoTop.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__